import { useSelector } from 'react-redux';
import { Text, Buttons, FlexContainer, Brand } from '@taxdown/piccolo-web';
import { locizeNS } from 'Services/i18n';
import { routeStateSelector } from 'Store/modules/router/selectors';
import { userAuthSelector } from 'Store/modules/auth/selectors';
import { useTranslation } from 'Hooks/useTranslation';
import FlowColLayout from 'Components/Layouts/FlowColLayout';
import { openUrlInNewNavigator } from 'Utils/links';
import FinSocial from 'Assets/images/Fin_Social.svg';
import { TAXDOWN_ASSETS_DOMAIN } from 'Constants/domains';
import { WHATSAPP_RESULT_ACCOUNT_ASSISTANCE } from 'Constants/whatsappLinks';
import * as Styled from './styles';

const FinSocialAccount = (): JSX.Element => {
  const { t } = useTranslation(locizeNS.RESULT);
  const paymentLaterProps = useSelector(routeStateSelector);
  const authInfo = useSelector(userAuthSelector);

  const copysInfo = {
    '1': t('Result.provider.service.devolution'),
    '2': t('Result.provider.service.sofipo'),
    '3': t('Result.provider.service.start'),
  };

  return (
    <FlowColLayout section={paymentLaterProps?.section} isFlow>
      <FlexContainer direction="column">
        <Styled.Container direction="column" align="center" gap="dimension_16">
          <Styled.LogoContainer align="center" justify="center" gap="dimension_16">
            <Brand mode="light" withIcon withText />
            <img src={FinSocial} alt="logo" />
          </Styled.LogoContainer>
          <Styled.ContentInfo direction="column" align="center" gap="dimension_24">
            <FlexContainer direction="column" align="center" gap="dimension_16">
              <Text type="headline" color="fresh" size="XS_L_S">
                {t('Result.process.provider')}
              </Text>
              <Text type="paragraphs" color="dark" size="M_M_S">
                {t('Result.process.info')}
              </Text>
            </FlexContainer>
            <FlexContainer direction="column" gap="dimension_16">
              {Object.keys(copysInfo)?.map((item, i) => (
                <FlexContainer gap="dimension_08" key={item}>
                  <Styled.BulletIcon type="fds_text_semibold_S" color="green_800">
                    {i + 1}
                  </Styled.BulletIcon>
                  <Text type="paragraphs" color="dark" size="S_S_S">
                    {copysInfo[item]}
                  </Text>
                </FlexContainer>
              ))}
            </FlexContainer>
            <Buttons.Classic
              label={t('Result.provider.start')}
              mode="success"
              size="s"
              onClick={() =>
                openUrlInNewNavigator(
                  `https://tarjetas.vipp.mx/Vipp/CreaCuenta.aspx?id=${authInfo?.id}`
                )
              }
            />
            <Text type="paragraphs" color="grey" size="XS_S_S" align="justify">
              {t('Result.provider.info')}
            </Text>
            <Styled.TabButton target="_blank" href={WHATSAPP_RESULT_ACCOUNT_ASSISTANCE}>
              <Styled.ImageContainer>
                <img src={`${TAXDOWN_ASSETS_DOMAIN}/illustrations/default/chat_s.png`} alt="icon" />
              </Styled.ImageContainer>
              <Text type="paragraphs" color="dark" size="M_L_S">
                {t('Result.Years.ChatBoxButton.CTA')}
              </Text>
            </Styled.TabButton>
          </Styled.ContentInfo>
        </Styled.Container>
      </FlexContainer>
    </FlowColLayout>
  );
};

export default FinSocialAccount;
